import BreakfastMenu from '../Assets/Breakfast Menu.png'
import BeveragesMenu from '../Assets/Beverages Menu.png'
import SandwichesMenu from '../Assets/Sandwiches Menu.png'
import LunchMenu from '../Assets/Lunch Menu.png'
import KidsMenu from '../Assets/Kids Menu.png'
import DrinksMenu from '../Assets/Drinks Menu.png'

export const menu = [
    {
        "src":  DrinksMenu,
        "alt": "Drinks Menu"
    },
    {
        "src":  BeveragesMenu,
        "alt": "Beverages Menu"
    },
    {
        "src": BreakfastMenu ,
        "alt": "Breakfast Menu"
    },
    {
        "src": LunchMenu ,
        "alt": "Lunch Menu"
    },
    {
        "src": SandwichesMenu,
        "alt": "Sandwiches Menu"
    },
    {
        "src": KidsMenu,
        "alt": "Kids Menu"
    }
]
